import { Component, Input } from '@angular/core';
import { ServiceProviderService } from '../services/service.provider.service';
import { ServiceProvider } from '../models/service.provider.model';
import { LookupService } from '../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-service-provider-form',
  templateUrl: './service-provider-form.component.html'
})
export class ServiceProviderFormComponent {
  constructor(public lookupService: LookupService, public service: ServiceProviderService, private notificationService: NotificationService) { }

  @Input() model: ServiceProvider;

  options: any = { format: 'YYYY-MM-DD' };

  ngOnInit() {

  }

  getCitiesByState(id) {
    this.lookupService.getCitiesByState(id);
  }

  onStateChanged(data: { value: string[] }): void {
    this.getCitiesByState(data);
  }

  submitted = false;

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.serviceProviderID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {
    
    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => {
        console.log(err);
      }
    )
  }

}
 
